import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { validate as isValidUUID } from 'uuid'

/**
 * Paste-a-uuid box that navigates to one SPIN's page. Only the format is checked here; a well-formed
 * but unknown id navigates and lands on the target page's own "not found" state.
 */
export const SpinUuidLookup: React.FC<{ toPath: (spinId: string) => string; className?: string }> = ({ toPath, className }) => {
  const navigate = useNavigate()
  const [value, setValue] = useState('')
  const [invalid, setInvalid] = useState(false)

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    const id = value.trim().toLowerCase()
    if (!isValidUUID(id)) {
      setInvalid(true)
      return
    }
    setInvalid(false)
    setValue('')
    navigate(toPath(id))
  }

  return (
    <form onSubmit={submit} className={`flex flex-col gap-1 ${className ?? ''}`}>
      <div className="join">
        <input
          type="text"
          aria-label="SPIN uuid"
          placeholder="SPIN uuid"
          className={`input input-bordered input-sm join-item font-mono w-80 ${invalid ? 'input-error' : ''}`}
          value={value}
          onChange={(e) => {
            setValue(e.target.value)
            setInvalid(false)
          }}
        />
        <button type="submit" className="btn btn-sm btn-primary join-item" disabled={value.trim() === ''}>
          Go
        </button>
      </div>
      {invalid && <span className="text-xs text-error">Not a valid uuid.</span>}
    </form>
  )
}
